// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__hDrn4","content":"Menu_content__kO86P","menuItem":"Menu_menuItem__1gCNC","imageIcon":"Menu_imageIcon__26MQG"};